import { FC, useState } from 'react';
import { useAdmins } from 'store/admins';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const AdminsFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: admins, isLoading } = useAdmins({ search });

  return (
    <SelectFilter
      {...props}
      options={admins?.items.map((admin) => ({
        key: admin.id,
        label: admin.fullName,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      asyncSearch
      multiple
    />
  );
};
